angular.module('mtic').service('LogReducer', function ($log, $q) {
      /**
       * LogReducer Class
       * @param {Array<UserRole>} userRoles
       * @param {Promise} getClassStudentsPromised
       */
      return function LogReducer(userRoles, userMapping, moduleResourceMapping){
            /**
             * A generalized getter function
             * this is where we specify our filtering syntax
             * @param  {Object} obj
             * @return {Array}
             */
            var generalizedGetter = function(obj){
                  return function(params) {
                        if(params === '*' || !params) {
                              return _.map(obj);
                        }else if(params.by && params.by === 'children'){
                            return filterByChilds(obj,params.list)
                        }else{
                          $log.warn('Todo, allow custom filters')
                          throw "Not Possible"
                        }
                  }
            }
            var filterByChilds = function(obj, list) {
              return _.filter(obj, function(row, id){
                var matchedAnds = _.filter(list, function(cond, key){
                  return _.filter(cond, function(condOr) {
                    return row[unpluralize(key)].id === condOr.id
                  }).length > 0
                })
                return matchedAnds.length >= _.map(list).length;
              })
            }
            var unpluralize = function(text){
              switch (text) {
                case 'users':
                  return 'user'
                  break;
              case 'resources':
                return 'resource'
                break;
              default:
                $log.warn('unpluralize function is really incomplete, returning ' + text)
                return text;
              }
            }
            /**
             * Classrooms Model
             */
            var classes = (function Classes(){
                  var classes = {};
                  var upsertClass = function(class_id){
                        if(!classes[class_id]) {
                              classes[class_id] = {
                                    id: class_id,
                                    users: {}
                              }
                        }
                        return classes[class_id];
                  }
                  return {
                        insertUserToClass: function(user, class_id) {
                              var _class = upsertClass(class_id);
                              _class.users[user.user_id] = user;
                              return _class;
                        },
                        get: generalizedGetter(classes)
                  }
            })();
            /**
             * Users Model
             */
            var users = (function Users(){
                  var users = {};
                  var upsertUser= function(user_id){
                        if(!users[user_id]) {
                              users[user_id] = _.extend(userMapping[user_id],{
                                    id: user_id,
                                    resource_sessions: {},
                                    classes: {}
                              })
                        }
                        return users[user_id];
                  }
                  return {
                        insertSessionToUser: function(user_id, resourceSession) {
                              var _user = upsertUser(user_id);
                              resourceSession.user = _user;
                              _user.resource_sessions[resourceSession.id] = resourceSession;
                              return _user;
                        },
                        get: generalizedGetter(users)
                  }
            })();
            /**
             * Resources Model
             */
            var resources = (function Resources(){
                  var resources = {};
                  var upsertResource= function(resource_id){
                        if(!resources[resource_id]) {
                              resources[resource_id] = _.extend(moduleResourceMapping[resource_id],{
                                    id: resource_id,
                                    resource_sessions: {},
                                    resources: resources
                              })
                        }
                        return resources[resource_id];
                  }
                  return {
                        insertSessionToResource: function(resource_id, resourceSession) {
                              var _resource = upsertResource(resource_id);
                              resourceSession.resource = _resource;
                              _resource.resource_sessions[resourceSession.id] = resourceSession;
                              return _resource;
                        },
                        get: generalizedGetter(resources)
                  }
            })();
            /**
             * Resource Sessions Model
             */
            var resourceSessions = (function ResourceSessions(){
                  var resourceSessions = {};
                  var stagedResources = [];
                  var processSession = function(superUniqueId) {
                        $q(function(resolve){
                          if(resourceSessions[superUniqueId]) {
                            var submitEvent;
                            var completeEvent;
                            var startEvent = resourceSessions[superUniqueId].eventLogs.filter(function(eventLog){
                              if(eventLog.event_name.split(':')[1] === 'score') {
                                completeEvent = eventLog
                              } else if(eventLog.event_name.split(':')[1] === 'complete') {
                                submitEvent = eventLog
                              }
                              return eventLog.event_name.split(':')[1] === "RESOURCE_LOAD_COMPLETE";
                            })
                            if(startEvent.length === 0) {// delete invalid sessions
                              delete resourceSessions[superUniqueId].resource.resource_sessions[superUniqueId];
                              delete resourceSessions[superUniqueId].user.resource_sessions[superUniqueId];
                              delete resourceSessions[superUniqueId];
                              return resolve();
                            }
                            resourceSessions[superUniqueId].status.invalid = false;
                            startEvent = startEvent[0];
                            var endEvent = resourceSessions[superUniqueId].eventLogs.reduce(function(eventLogA, eventLogB){
                              return moment(eventLogA.time_stamp_local).isBefore(eventLogB.time_stamp_local) ? eventLogB : eventLogA
                            })
                            resourceSessions[superUniqueId].time = {
                              start: startEvent.time_stamp_local,
                              end: endEvent.time_stamp_local,
                              spent: moment(endEvent.time_stamp_local).diff(startEvent.time_stamp_local, 'm') // in minutes
                            }
                            if(submitEvent) {
                              resourceSessions[superUniqueId].status.complete = true
                            }
                            if(completeEvent) {
                              resourceSessions[superUniqueId].status.hasScore = true
                              resourceSessions[superUniqueId].status.complete = true
                              var eventData = JSON.parse(completeEvent.event_data);
                              resourceSessions[superUniqueId].score = eventData.score || 1 //since this variable was not here prior to 2017-05-25
                            }
                          }
                          return resolve(resourceSessions[superUniqueId]);
                        })
                  }
                  var upsertSession= function(user_id, class_id, session_id, resource_session_id, resource_id, eventLog){
                        var superUniqueId = [class_id, user_id, session_id, resource_id, resource_session_id].join('/');
                        if(!resourceSessions[superUniqueId]) {
                              resourceSessions[superUniqueId] = {
                                    id: superUniqueId,
                                    class_id: class_id,
                                    session_id: session_id,
                                    resource_session_id: resource_session_id,
                                    user_id: user_id,
                                    eventLogs: [],
                                    status: {
                                          complete: false, //if it was complete
                                          invalid: true, // this would mean we could not process this event (maybe missing a start)
                                          hasScore: false, // has a score
                                    },
                                    score: null,
                                    time: {}
                              }
                        }
                        resourceSessions[superUniqueId].eventLogs.push(eventLog);
                        stagedResources.push(superUniqueId)
                        return resourceSessions[superUniqueId];
                  }
                  return {
                        upsert: function(user_id, class_id, session_id, resource_session_id, resource_id, row) {
                              var _resourceSession = upsertSession(user_id, class_id, session_id, resource_session_id, resource_id, row)
                              var _user = users.insertSessionToUser(user_id, _resourceSession)
                              var _resource = resources.insertSessionToResource(resource_id,_resourceSession)
                              _resourceSession.resource = _resource;
                              _resourceSession.class =_user.classes[class_id] = classes.insertUserToClass(_user, class_id)
                              _resourceSession.user = _user;
                              return _resourceSession;
                        },
                        bulkInsert: function(user_id, class_id, appEvents) {
                              var self = this;
                              return $q.all(appEvents.map(function(appEvent){
                                    return $q(function(resolve){
                                          resolve(self.upsert(
                                                user_id,
                                                class_id,
                                                appEvent.session_id,
                                                appEvent.resource_session_id,
                                                appEvent.resource_id,
                                                appEvent
                                          ))
                                    })
                              })).then(function(){
                                    return $q.all(stagedResources.map(processSession))
                              }).then(function(){
                                    return resourceSessions;
                              })
                        },
                        get: generalizedGetter(resourceSessions)
                  }
            })()

            /**
             * Main Looper
             * @param  {UserRole} userRole
             * @return {Array<resourceSessions>}
             */
            var groupAppEventsFromUserRole = function(userRole) {
                  var user_id = userRole.user_id;
                  var class_id = userRole.group_id;
                  return resourceSessions.bulkInsert(user_id, class_id, userRole.User.AppEvents)
            }
            /**
             * Flags
             */
            var done = false;
            var processing = false;
            var awaitingProcesses = [];
            /**
             * Init function
             * @return {Promise}
             */
            var init = function() {
                  processing = true;
                  return $q.all(userRoles.map(groupAppEventsFromUserRole)).then(function(){
                        done = true;
                        awaitingProcesses.map(function(next){
                              next();
                        })
                  })

            }
            init();
            /**
             * Main Output of this class
             * @param  {String} model      classes|users|resourceSessions
             * @param  {String|Object} conditions
             * @return {Promise<Array>}
             */
            var getData = function(model, conditions) {
                  $log.debug('[[LogReducer]] -START GET', model, conditions)
                  if(!done) {
                        if(processing) {
                              return $q(function(resolve){
                                    awaitingProcesses.push(resolve)
                              }).then(function(){
                                    return getData(model, conditions)
                              })
                        }     else  {
                              return init().then(function(){
                                    return getData(model, conditions)
                              })
                        }
                  }else{
                        $log.debug('[[LogReducer]] -PROCESSING GET', model, conditions)
                        return $q(function(resolve, reject){
                              switch (model) {
                                    case 'users':
                                          $log.debug('[[LogReducer]] -DONE GET', model, conditions)
                                          return resolve(users.get(conditions))
                                    case 'classes':
                                          $log.debug('[[LogReducer]] -DONE GET', model, conditions)
                                          return resolve(classes.get(conditions))
                                    case 'resourceSessions':
                                          $log.debug('[[LogReducer]] -DONE GET', model, conditions)
                                          return resolve(resourceSessions.get(conditions))
                                    case 'resources':
                                          $log.debug('[[LogReducer]] -DONE GET', model, conditions)
                                          return resolve(resources.get(conditions))
                                    default:
                                          $log.debug('[[LogReducer]] -FAILED GET', model, conditions)
                                          reject(new Error("Invalid model passed to `getAppLogs` " + model));
                              }
                        })
                  }
            }
            return getData;
      }
})
